<div class="virtual-printer">
  <app-upload-virtual-printer [user]="user" (updateDownloadableList)="updateVirtualPrinterLists()" [virtualPrinterList]="virtualPrinterList" [packagedVersion]="packagedVersion" [displayUploadVirtualPrinterPanel]="displayUploadVirtualPrinterPanel"></app-upload-virtual-printer>
  <div id="download-virtual-printer">
    <app-download-virtual-printer [user]="user"  (updateDownloadableList)="updateVirtualPrinterLists()" [virtualPrinterList]="virtualPrinterList" [virtualPrinterPackageList]="virtualPrinterPackageList"></app-download-virtual-printer>
  </div>
</div>
